import {
	baseUrl
} from './env'
import md5 from 'js-md5';
export let appKey = "0136652484";
let scret = '6D9D23399E4BF100FB8F93CC9160D511';
import { Loading , Message} from 'element-ui';
import {getCookie,delCookie} from '../utils'

export default async(url = '', data = {}, type = 'GET', method = 'fetch') => {

	let loadingInstance = Loading.service({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0)'
	  })
	  if(getCookie('isLogin')==null){
		location.href='/#/login'
	  }
	type = type.toUpperCase();
	url = baseUrl + url;
	console.log(url)
	if (type == 'GET') {
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
	}
	

	if (window.fetch && method == 'fetch') {
		let timestamp = Date.parse(new Date())
		let requestConfig = {
			credentials: 'include',
			method: type,
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Timestamp':timestamp,
				'Sign':sign(appKey,timestamp),
				//'Sign':'7206C39584DBEDFB11882980E1890012',
				'APP-Key':appKey,
				'Authorization':localStorage.getItem('mgt_user')?localStorage.getItem('mgt_user').replace(/\"/g, ""):'',
				//  "Authorization":'70EFDF2EC9B086079795C442636B55FB.67494450003b4254b907e200f2e8bd28'
			},
			mode: "cors", 
			// cache: "force-cache"
		}

		if (type == 'POST'||type == 'PUT'||type == 'DELETE') {
			requestConfig.headers={
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				// 'Content-Type': 'application/x-www-form-urlencoded',
				'Timestamp':timestamp,
				'Sign':sign(appKey,timestamp),
				//'Sign':'7206C39584DBEDFB11882980E1890012',
				'APP-Key':appKey,
				'Authorization':localStorage.getItem('mgt_user')?localStorage.getItem('mgt_user').replace(/\"/g, ""):'',
				// Authorization:'70EFDF2EC9B086079795C442636B55FB.1a893b833d774fb5ac51a1e07f1ee536'
			}
			
			
			Object.defineProperty(requestConfig, 'body', {
				value: JSON.stringify(data)
			})
		}
		
		if(url.indexOf('/contract/file/url')!=-1||url.indexOf('/contract/credit/url')!=-1){
			requestConfig.headers['Authorization']=''
		}
		try {
			setTimeout(()=>{
				loadingInstance.close()
				  },500)
			const response = await fetch(url, requestConfig);
			const responseJson = await response.json();
			if(responseJson.code!=0){
				if(responseJson.code==100||responseJson.code==401){
					localStorage.removeItem('mgt_user');
					delCookie('isLogin')
					location.href='/#/login'
				}
				Message({ showClose: true, message: responseJson.msg, type: "error" });
			}
			return responseJson
		} catch (error) {
			setTimeout(()=>{
				loadingInstance.close()
				  },500)
			throw new Error(error)
		}
	} else {
		return new Promise((resolve, reject) => {
			let requestObj;
			
			if (window.XMLHttpRequest) {
				requestObj = new XMLHttpRequest();
			} else {
				requestObj = new ActiveXObject;
			}

			let sendData = '';
			if (type == 'POST') {
				sendData = JSON.stringify(data);
			}

			requestObj.open(type, url, true);
			requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			requestObj.send(sendData);

			requestObj.onreadystatechange = () => {
			
				
				if (requestObj.readyState == 4) {
					if (requestObj.status == 200) {
						let obj = requestObj.response
						if (typeof obj !== 'object') {
							obj = JSON.parse(obj);
						}
						resolve(obj)
					} else {
						reject(requestObj)
					}
				}
			}
		})
	}
}



export function sign( appKey, timestamp) {
	let serial = joinParamStr(appKey,timestamp);
	let sign = md5(md5(serial).toUpperCase() + scret).toUpperCase();
	return sign;
}


export function joinParamStr( appKey, timestamp){
	let sb = "appKey="+appKey+"&timestamp="+timestamp
	return sb;
}


// WEBPACK FOOTER //
// ./src/config/fetch.js